import { render, staticRenderFns } from "./AccordianItem.vue?vue&type=template&id=2d96d035&scoped=true&"
import script from "./AccordianItem.vue?vue&type=script&lang=js&"
export * from "./AccordianItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d96d035",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/sivaram/work/carthike/whatsapp-crm-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d96d035')) {
      api.createRecord('2d96d035', component.options)
    } else {
      api.reload('2d96d035', component.options)
    }
    module.hot.accept("./AccordianItem.vue?vue&type=template&id=2d96d035&scoped=true&", function () {
      api.rerender('2d96d035', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/AccordianItem.vue"
export default component.exports